import { qportalApi } from "./qportal-api";
const getDashboardDetails = () => {
    return qportalApi.get(`dashboard`);
};
const dashboardApi = {
    getDashboardDetails
};
export default dashboardApi;
